import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const slideOut = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(100%); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const Backdrop = styled.div<{ closing: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 3000000000;
  background: ${(props) => props.theme.$black}66;
  animation: ${(props) => (props.closing ? fadeOut : fadeIn)} 0.4s ease forwards;
`;

export const Panel = styled.div<{ closing: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 3000000001;
  background: ${(props) => props.theme.$white};
  display: flex;
  flex-direction: column;
  box-shadow: -8px 0 24px ${(props) => props.theme.$black}33;
  animation: ${(props) => (props.closing ? slideOut : slideIn)} 0.4s ease forwards;
  will-change: transform;

  .card-modal-body,
  .card-modal-main,
  .card-modal-section {
    flex: 1;
    min-height: 0;
  }

  .card-modal-main {
    min-width: 0;
  }

  .card-modal-main h4 {
    color: ${(props) => props.theme.$dark};
  }
`;
